export default {
  en: {
    actions: {
      update: 'Update',
    },
    snack: {
      feed_delete_success: 'Source deleted successfully',
      generic_error: 'Something went wrong',
    },
    confirm_dialog_msg: { default: 'Are you sure?' },
  },
};
